export default __webpack_public_path__ + "static/bbbc-landing-faded-bg-tablet-33f4aca1522227afa6137b644da4fc35.webp";